<template>
  <div></div>
</template>

<script>
export default {
  name: 'NovoManualDeRedacao',

  mounted() {
    // Dispara o evento no Google Analytics
    this.$gtag.event('download_pdf', {
      file_name: 'manual_redacao_goias_2026'
    });

    // Pequeno delay para garantir envio do evento
    setTimeout(() => {
      window.location.href = 'https://goias.gov.br/casacivil/wp-content/uploads/sites/47/2026/03/Nova-Edicao-do-Manual-de-Redacao-do-Governo-do-Estado-de-Goias.pdf';
    }, 300);
  }
}
</script>